import { render, staticRenderFns } from "./ChamberOfCommerceTypeCase.vue?vue&type=template&id=922d71dc&scoped=true"
import script from "./ChamberOfCommerceTypeCase.vue?vue&type=script&lang=js"
export * from "./ChamberOfCommerceTypeCase.vue?vue&type=script&lang=js"
import style0 from "./ChamberOfCommerceTypeCase.vue?vue&type=style&index=0&id=922d71dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922d71dc",
  null
  
)

export default component.exports